import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Contacto from './components/Contacto.vue'
import Servicios from './components/Servicios.vue'
import Solicitar_QR from './views/Solicitar_QR.vue'
//import Whatsapp from './components/Whatsapp.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/contacto',
      name: 'contacto',
      component: Contacto
    },
    {
      path: '/servicios',
      name: 'servicios',
      component: Servicios
    },
    {
      path: '/Solicitar_QR',
      name: 'Solicitar_QR',
      component: Solicitar_QR
    },
    /*{
      path: '/Whatsapp',
      name: 'Whatsapp',
      component: Whatsapp
    },*/
    {
      path: '*',
      redirect: '/'
    }
  ],
  //regresar hasta arriba
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  }
})
